import {
  type KyrgyzstanOwnerModerationStatusFilter,
  KyrgyzstanWebviewOwnerApi,
} from 'shared/api/kyrgyzstan/webview-owner'

import type { MyObject, MyObjectStatus } from '../model/types'

import {
  mapOwnerModerationDraftToMyObject,
  mapOwnerRealtyObjectToMyObject,
} from './map-owner-realty-object-to-my-object'

interface FetchMyObjectsPageParams {
  page: number
  pageSize: number
  signal?: AbortSignal
}

export interface MyObjectsPageResult {
  items: MyObject[]
  page: number
  totalPages: number
}

type FetchMyObjectsPage = (
  params: FetchMyObjectsPageParams,
) => Promise<MyObjectsPageResult>

const fetchActiveObjects: FetchMyObjectsPage = async ({
  page,
  pageSize,
  signal,
}) => {
  const { data } = await KyrgyzstanWebviewOwnerApi.getRealtyObjects(
    {
      page,
      page_size: pageSize,
    },
    signal,
  )

  return {
    items: data.data.map(mapOwnerRealtyObjectToMyObject),
    page: data.page,
    totalPages: data.total_pages || 1,
  }
}

const createModerationObjectsFetcher =
  (
    status: Exclude<MyObjectStatus, 'active'>,
    statusFilter: KyrgyzstanOwnerModerationStatusFilter,
  ): FetchMyObjectsPage =>
  async ({ page, pageSize, signal }) => {
    const { data } = await KyrgyzstanWebviewOwnerApi.getModerationDrafts(
      {
        page,
        page_size: pageSize,
        status_filter: statusFilter,
      },
      signal,
    )

    return {
      items: data.data.map((draft) =>
        mapOwnerModerationDraftToMyObject(draft, status),
      ),
      page: data.page,
      totalPages: data.total_pages || 1,
    }
  }

export const myObjectsPageFetchers: Record<MyObjectStatus, FetchMyObjectsPage> =
  {
    active: fetchActiveObjects,
    submitted: createModerationObjectsFetcher(
      'submitted',
      'pending_moderation',
    ),
    cancelled: createModerationObjectsFetcher('cancelled', 'rejected'),
  }
